import type { Guide } from '../types';

/** S-21.10-05 — korekty paliwowe: kartoteka i informacja na zleceniu (scenariusz e2e 19, BR-CS-12, BR-ADM-04). */
export const guide: Guide = {
  flagKey: 'fuelSurcharges',
  title: 'Korekty paliwowe — kartoteka i informacja na zleceniu',
  whatItDoes:
    'Kartoteka korekt paliwowych: rodzaje korekt (kto je ustala, okres, moment wg daty załadunku albo rozładunku), wartości w okresach i przypisania kontrahentów z datami. Wartości przyjdą od CS — do tego czasu pole jest puste, nigdy zero. Na karcie zlecenia i prezlecenia stoi „Korekta paliwowa: rodzaj, okres, wartość na dzień” — tylko informacja, bez wpływu na marżę i koszt.',
  audience: ['CS', 'Administracja', 'planista FTL (podgląd na zleceniu)'],
  presentationItems: ['S-21.10-05'],
  steps: [
    {
      route: '/fuel-surcharges',
      target: 'fuel-types',
      title: 'Rodzaje korekt',
      description:
        'Rodzaje startowe to wartości robocze z odpowiedzi CS: korekta klienta w wariantach okresu i momentu, korekta Marathonu PL i DE, korekta magazynowa. Czego nie ustalono, stoi jako „nieustalony”.',
      action: 'Otwórz „Korekty paliwowe” w menu (grupa „Administracja”).',
      recorder: { account: 'admin' },
    },
    {
      route: '/fuel-surcharges',
      target: 'fuel-values*',
      title: 'Wartości w okresach',
      description:
        'Dla wybranego rodzaju wpisuje się wartość (procent albo kwota) na okres od–do, ze źródłem. Bez wartości pole mówi, że przyjdą od CS. Każda zmiana wymaga powodu i trafia do historii.',
      action: 'Wybierz zakładkę „Wartości”, rodzaj korekty i „Dodaj wartość”.',
      recorder: {
        account: 'admin',
        actions: [
          { kind: 'clickText', text: 'Wartości' },
          { kind: 'select', label: 'Rodzaj korekty', option: 'Korekta klienta — tygodniowa, wg daty załadunku' },
        ],
      },
    },
    {
      route: '/contractors/:contractorId/show',
      record: { description: 'dowolny kontrahent z kartoteki', listPath: '/contractors' },
      target: 'contractor-fuel-surcharges',
      title: 'Korekta przy kontrahencie',
      description:
        'Na karcie kontrahenta: korekta obowiązująca dziś i przypisania z datami. Kontrahent ma jedną korektę naraz — nowe przypisanie kończy poprzednie tylko za zgodą.',
      action: 'Na karcie kontrahenta kliknij „Przypisz korektę”, wybierz rodzaj, datę i wpisz powód.',
      recorder: { account: 'admin', demo: { kind: 'contractorOfOrder', number: 'DEMO/2026/09/001' } },
    },
    {
      route: '/user-offers/:orderId/show',
      record: { description: 'zlecenie kontrahenta z przypisaną korektą', listPath: '/user-offers', listFilter: { forklift: 'hide' } },
      target: 'fuel-surcharge-section',
      title: 'Informacja na zleceniu',
      description:
        'W sekcji „Cena i finanse” zlecenia: korekta kontrahenta na dzień załadunku albo rozładunku — albo powód, dlaczego jej nie ma. Marża i koszt się nie zmieniają.',
      action: 'Na karcie zlecenia rozwiń „Cena i finanse”.',
      recorder: {
        account: 'ftl',
        demo: { kind: 'order', number: 'DEMO/2026/09/001' },
        actions: [{ kind: 'expand', target: 'order-section-price' }],
      },
    },
    {
      route: '/fuel-surcharges',
      target: 'fuel-import',
      title: 'Plik „klient → korekta” od CS',
      description:
        'Plik CSV albo Excel (identyfikator z TMS albo NIP, rodzaj, od kiedy) — najpierw podgląd z raportem nieznanych kontrahentów i rodzajów, zapis dopiero po potwierdzeniu.',
      action: 'Wybierz zakładkę „Plik od CS”, wskaż plik i kliknij „Podgląd”.',
      recorder: { account: 'admin', actions: [{ kind: 'clickText', text: 'Plik od CS' }] },
    },
  ],
};
